export function saveToSessionStorage(key: string, value: string) {
  try {
    return sessionStorage.setItem(key, value);
  } catch {
    return null;
  }
}

export function readFromSessionStorage(key: string) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function getKeysFromSessionStorage() {
  try {
    return Object.keys(sessionStorage);
  } catch {
    return [];
  }
}
